// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3e5xh","content":"GlobalSearch_content__3Ais_"};